import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { WebshopService } from 'src/app/services/webshop/webshop.service';

@Component({
  selector: 'app-brand-add-edit-modal',
  templateUrl: './brand-add-edit-modal.component.html',
  styleUrls: ['./brand-add-edit-modal.component.scss']
})
export class BrandAddEditModalComponent implements OnInit {
  @Input() modelId: any;
  @Input() modalName: string;
  @Input() title: string;
  @Input() modalType: string;
  @Input() routeName: string;
  @Input() clickedBrandId: string;
  @Output() brandFunction = new EventEmitter<{ int: any, routeName: any }>();
  submitted: any = false
  brand: any = false
  isSuccess: any = false
  loading: any = false
  formMessage: any = ''
  brandStatus: any = [{ id: 1, name: 'Active', value: 1 }, { id: 2, name: 'Inactive', value: 0 },]


  brandForm: FormGroup = new FormGroup({
    name: new FormControl('', [Validators.required]),
    status: new FormControl('', [Validators.required]),
    domain: new FormControl('', [Validators.required]),
  })

  get brandControls() { return this.brandForm.controls; }

  constructor(
    private webshopService: WebshopService,
  ) {

  }

  ngOnInit(): void { }

  clearFormData() {
    this.submitted = false
    this.brandForm.patchValue({
      name: '',
      status: '',
      domain: '',
    })
  }

  getBrandDataByID(brandId: any) {
    this.webshopService.getBrandById(brandId).subscribe(res => {
      this.brandForm.patchValue({
        name: res.data.brand_name,
        status: res.data.status,
        domain: res.data.domain,
      })

    });
  }

  onAddClick() {
    this.submitted = true
    this.loading = true
    if (this.brandForm.invalid) {
      this.formMessage = "Please Fill All the required fields"
      this.loading = false
    } else {
      this.webshopService.addBrand(this.brandForm.value)
        .subscribe({
          next: (res) => {
            console.log(res)
            this.isSuccess = true;
            this.formMessage = 'Successfully added the Brand!'
            this.loading = false;
            this.brandFunction.emit({ int: this.brandForm.value, routeName: this.routeName });
          },
          error: (error) => {
            console.log(error)
            this.isSuccess = false;
            this.formMessage = error;
            this.loading = false;
          }
        })
    }
  }

  onEditClick() {
    this.submitted = true
    this.loading = true
    if (this.brandForm.invalid) {
      this.formMessage = "Please Fill All the required fields"
      this.loading = false
    } else {
      this.webshopService.updateBrand(this.clickedBrandId, this.brandForm.value)
        .subscribe({
          next: (res) => {
            console.log(res)
            this.isSuccess = true;
            this.formMessage = 'Successfully updated the Brand!'
            this.loading = false;
            this.brandFunction.emit({ int: this.brandForm.value, routeName: this.routeName });
          },
          error: (error) => {
            console.log(error)
            this.isSuccess = false;
            this.formMessage = error;
            this.loading = false;
          }
        })
    }
  }
}
